import { GridRequest } from 'projects/app-core/src/models/gridRequest';
import { GridResponse } from 'projects/app-core/src/models/gridResponse';

export enum LyfisPersistedDiseaseScoresSort {
  CREATED_AT = 'createdAt',
  DRS_SCORE = 'drsScore',
  PDH_SCORE = 'pdhScore',
  QUESTIONNAIRE_SCORE = 'questionnaireScore',
  LAB_MARKERS_SCORE = 'labMarkersScore',
}

export enum LyfisPersistedDiseaseScoresFilter {
  DISEASE_ID = 'diseaseId',
  BAND = 'band',
  STATUS = 'status',
  INSIGHTS_GENERATING_STATUS = 'insightsGeneratingStatus',
  TEST_USERS = 'TEST_USERS',
}

export enum LyfisPersistedDiseaseScoresSearch {
  DISEASE_NAME = 'diseaseName',
}

export enum LyfisPersistedDiseaseScoresDateFilter {
  CREATED_AT = 'createdAt',
}

export interface LyfisPersistedDiseaseScoresGridRequest
  extends GridRequest<
    LyfisPersistedDiseaseScoresSort,
    LyfisPersistedDiseaseScoresFilter,
    LyfisPersistedDiseaseScoresSearch,
    LyfisPersistedDiseaseScoresDateFilter
  > {}

export interface LyfisPersistedDiseaseScoreRow {
  id: string;
  snapshotId: string;
  diseaseId: string;
  diseaseName: string;
  drsScore: number | null;
  pdhScore: number | null;
  band: string | null;
  questionnaireScore: number | null;
  labMarkersScore: number | null;
  status?: string;
  insightsGeneratingStatus?: string;
  createdAt?: number;
}

export interface LyfisPersistedDiseaseScoresFilterData {
  diseaseId?: string[];
  band?: string[];
  status?: string[];
  insightsGeneratingStatus?: string[];
}

export interface LyfisPersistedDiseaseScoresGridResponse
  extends GridResponse<
    LyfisPersistedDiseaseScoresFilterData | undefined,
    LyfisPersistedDiseaseScoreRow
  > {}
